















































































































































import { Component, Vue } from 'vue-property-decorator';
import SlideIn from '@/components/basic/SlideIn.vue';
import StarRating from 'vue-star-rating';
import { stProjectApi, stProjectTaskApi, stStopwatchApi, stTagApi } from '@/services/st-api';
import {
  ProjectFilter,
  ProjectTaskFilter, ProjectTaskSelectListForProjectQuery,
  ProjectTimeEntryViewModel,
  RateRuleAmountFilter,
  StopwatchEditModel,
  StSelectListItem,
  StSelectListItemGroup,
  TagViewModel
} from '@/services/api/nswag/stapiclient_generated';
import { UserStore } from '@/store/user-module';
import { StopwatchStore } from '@/store/stopwatch-store';
import TimeEntryRateInput from '@/views/TimeEntries/TimeEntryEdit/TimeEntryRateInput.vue';
import DescriptionTextarea from '@/views/TimeEntries/Components/DescriptionTextarea.vue';
import StCurrencyInput from '@/components/basic/StCurrencyInput.vue';

@Component({
  components: {
    StCurrencyInput,
    SlideIn,
    TimeEntryRateInput,
    DescriptionTextarea,
    StarRating
  }
})
export default class StopwatchOldLayoutEdit extends Vue {
  private listPage = 'TimeEntries';
  loading: boolean = true;
  saveLoading = false;
  saveStopLoading = false;

  projects: StSelectListItemGroup[] = [];
  projectTasksGrouped: StSelectListItemGroup[] = [];
  selectedProject: ProjectTimeEntryViewModel = new ProjectTimeEntryViewModel();
  tags: TagViewModel[] = [];
  stopwatchEditModel: StopwatchEditModel = StopwatchEditModel.fromJS({});
  rateAmount: number = 0;
  watcher: any;

  delayLoading = false;
  initialized = false;

  async mounted() {
    try {
      this.openSlideIn();

      this.loading = true;

      this.stopwatchEditModel = await stStopwatchApi.getEditModel();
      this.projects = await stProjectApi.getSelectListForTimeTracking();

      await this.loadSelectedProject();
      await this.loadProjectTasks();

      this.tags = await stTagApi.getListForTimeEntry(this.stopwatchEditModel?.id ?? 0);
      this.selectedProject = await stProjectApi.getTimeEntryViewModel(this.stopwatchEditModel.projectId!);

      this.watcher = this.$watch('stopwatchEditModel.projectId', async () => {
        try {
          this.delayLoading = true;
          await this.projectChanged();
          this.stopwatchEditModel.projectTaskId = this.selectedProject.preselectedProjectTaskId;
        } finally {
          this.delayLoading = false;
        }
      });

      await this.$nextTick();
      this.initialized = true;
    } finally {
      this.loading = false;
    }
  }

  get useProjectTimeTracking() {
    return !UserStore.userSettings.useBasicTimeTracking && !UserStore.userSettings.isBasicTimeTrackingUser;
  }

  beforeDestroy() {
    this.watcher();
  }

  async loadSelectedProject() {
    this.selectedProject = await stProjectApi.getTimeEntryViewModel(this.stopwatchEditModel.projectId!);
  }

  async loadProjectTasks() {
    this.projectTasksGrouped = await stProjectTaskApi.getSelectListForProject(ProjectTaskSelectListForProjectQuery.fromJS({
      projectId: this.selectedProject.id!
    }));
  }

  openSlideIn() {
    (this.$refs.slideIn as SlideIn).open();
  }

  closeSlideIn() {
    (this.$refs.slideIn as SlideIn).close();
  }

  slideOutClosed() {
    this.$router.push({ name: this.listPage });
  }

  get todayIso() {
    return UserStore.userNowDateTime.toISODate();
  }

  get canViewRates() {
    return UserStore.userSettings.CanViewRates && !UserStore.userSettings.noRates;
  }

  get userSettings() {
    return UserStore.userSettings;
  }

  get hasRates() {
    return this.userSettings.hasRates;
  }

  get isBillableNotChangeable() {
    return this.userSettings.timeEntryIsBillableNotChangeable;
  }

  get extraFields() {
    return this.stopwatchEditModel.timeEntryExtraFields;
  }

  get currency() {
    return UserStore.userSettings.currency;
  }

  get stopwatch() {
    return StopwatchStore.StopwatchModel;
  }

  get isRunning() {
    return StopwatchStore.IsRunning;
  }

  async handleSaveAndStop() {
    //@ts-ignore
    await this.$refs.observer.handleSubmit(this.saveAndStop);
  }

  async saveAndStop() {
    try {
      this.saveStopLoading = true;

      await stStopwatchApi.edit(this.stopwatchEditModel);
      await StopwatchStore.stopStopwatch();
      this.closeSlideIn();
    } finally {
      this.saveStopLoading = false;
    }
  }

  async submit() {
    try {
      this.saveLoading = true;
      await stStopwatchApi.edit(this.stopwatchEditModel);
      await StopwatchStore.loadStopwatch();
      this.closeSlideIn();
    } finally {
      this.saveLoading = false;
    }
  }

  //
  get selectedProjectHasTasks() {
    return this.selectedProject.hasProjectTasks;
  }

  get rateRuleAmountFilter() {
    return RateRuleAmountFilter.fromJS({
      customerId: undefined,
      projectId: this.stopwatchEditModel.projectId,
      projectTaskId: this.stopwatchEditModel.projectTaskId
    });
  }

  async projectChanged() {
    await this.loadSelectedProject();
    await this.loadProjectTasks();

    this.stopwatchEditModel.isBillable = this.selectedProject.isBillable;
  }
}
